import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=05a6bafc&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=05a6bafc&prod&lang=scss&scoped=true"
import style1 from "./AppSidebar.vue?vue&type=style&index=1&id=05a6bafc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6bafc",
  null
  
)

export default component.exports